
import { NavBarActionType } from "../action-types/navBarTypes"
import { Action } from "../actions/navBarActions"

const initialState: boolean = true

const reducer = (state: boolean = initialState, action: Action) => {
    switch (action.type) {
        case NavBarActionType.SWITCH:
            return action.payload
        default:
            return state
    }
}

export default reducer